// extracted by mini-css-extract-plugin
export var activeDot = "_73-c";
export var buttonContainer = "_73-9";
export var channelButton = "_73-a";
export var clickable = "_73-d";
export var content = "_73-0";
export var contentFull = "_73-2";
export var contentThird = "_73-1";
export var contentWrapper = "_73-7";
export var description = "_73-5";
export var heightShort = "_73-f";
export var image = "_73-3";
export var imageContainer = "_73-4";
export var selectButton = "_73-e";
export var spinnerContainer = "_73-b";
export var titleContent = "_73-8";
export var titleWrapper = "_73-6";